export default __webpack_public_path__ + "static/media/import_properties_model.b9a83707.xlsx";